import React from 'react';
import { styled } from '@mui/material';
import { SideButton } from './SideButton';

type Props = {
    text: string;
    selected: boolean;
    to: string;
    onClick?: () => void;
    className?: string;
};

const StySideButton = styled(SideButton, {
    name: 'StySideButton',
    shouldForwardProp(propName) {
        return propName !== 'expanded' && propName !== 'selected';
    },
})<{ expanded: boolean; selected: boolean }>(
    ({ expanded, selected, theme }) => ({
        fontWeight: selected
            ? theme.typography.fontWeightBold
            : theme.typography.fontWeightRegular,
        marginBottom: '0.25rem',
        fontSize: '0.9em',
        paddingLeft: '2rem',
        minWidth: expanded ? '11.25rem' : '2.5rem',
        color: 'white',
        '&:hover': {
            color: 'white',
        },
    }),
);

export default function SubMenuSideButton({
    text,
    onClick,
    selected,
    to,
    className,
}: Props) {
    return (
        <StySideButton
            selected={selected}
            expanded
            text={text}
            onClick={onClick}
            to={to}
            className={className}
        />
    );
}
